import React from 'react';
import HeroSection from '../../components/ui/HeroSection';
import ProjectsSection from './ProjectsSection';
// import Select from './Select';
// import MUISelect from './MUISelect';

const Portfolio = () => (
  <>
    <HeroSection navList={['home', 'portfolio']} title="my portfolio" />

    {/* <MUISelect /> */}

    {/* <Select /> */}
    <ProjectsSection />
  </>
);

export default Portfolio;
